<div [formGroup]="form">
	<div class="input-group input-group-sm mb-2">
		<span class="input-group-text">
			<span class="text-danger">*</span>
			To
		</span>
		<tag-input formControlName="toMail" class="form-control"
			[placeholder]="'Please add email address and press space bar.'"
			[secondaryPlaceholder]="'Please add email address and press space bar.'" [separatorKeys]="[' ']"
			[editable]="true" [validators]="emailvalidators" [errorMessages]="emailerrormessages" [addOnPaste]="true"
			[pasteSplitPattern]="splitPattern" [separatorKeyCodes]="[13]">
		</tag-input>
	</div>
	<div class="input-group input-group-sm mb-2">
		<span class="input-group-text">
			Cc
		</span>
		<tag-input formControlName="ccMail" class="form-control"
			[placeholder]="'Please add email address and press space bar.'"
			[secondaryPlaceholder]="'Please add email address and press space bar.'" [separatorKeys]="[' ']"
			[editable]="true" [validators]="emailvalidators" [errorMessages]="emailerrormessages" [addOnPaste]="true"
			[pasteSplitPattern]="splitPattern" [separatorKeyCodes]="[13]">
		</tag-input>
	</div>
	<div class="input-group input-group-sm mb-2">
		<span class="input-group-text">
			Bcc
		</span>
		<tag-input formControlName="bccMail" class="form-control"
			[placeholder]="'Please add email address and press space bar.'"
			[secondaryPlaceholder]="'Please add email address and press space bar.'" [separatorKeys]="[' ']"
			[editable]="true" [validators]="emailvalidators" [errorMessages]="emailerrormessages"
			[modelAsStrings]="true" [addOnPaste]="true" [pasteSplitPattern]="splitPattern" [separatorKeyCodes]="[13]">
		</tag-input>
	</div>
	<div class="input-group input-group-sm mb-2">
		<span class="input-group-text">
			<span class="text-danger">*</span>
			Subject
		</span>
		<input class="form-control" formControlName="subject" />
	</div>
	<div class="mb-editor text_editor_container">
		<quill-editor formControlName="body" [modules]="quillConfig" placeholder="Mail body"></quill-editor>
	</div>
</div>